// @flow
export const SET_HOME = 'set/home';
export const HOME_UPDATED = 'home/updated';
export const HOME_REJECTED = 'home/rejected';
export const COMMENTS_HOME = 'comments/home';
export const COMMENT_CREATED = 'comments/created';
